import { usePage } from "@inertiajs/react"
import { Alert, Snackbar } from "@mui/material"
import { useEffect, useState } from "react"
import { flashAutoHideMs, flashMessages, flashSignature, type IFlash, type IFlashMessage } from "@/lib/flash"

type SharedProps = {
    flash?: IFlash | null
}

export default function FlashMessages() {
    const { flash } = usePage<SharedProps>().props
    const [messages, setMessages] = useState<IFlashMessage[]>([])

    // Keyed on the flash itself, not on mount: this layout stays mounted across
    // Inertia visits, so a mount-only effect would show the first warning and
    // silently drop every later one.
    const signature = flashSignature(flash)
    useEffect(() => {
        setMessages(flashMessages(flash))
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [signature])

    const dismiss = (key: IFlashMessage["key"]) =>
        setMessages(current => current.filter(m => m.key !== key))

    return (
        <>
            {messages.map((message, index) => (
                <Snackbar
                    key={message.key}
                    open
                    anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
                    autoHideDuration={flashAutoHideMs(message.severity)}
                    onClose={(_event, reason) => { if (reason !== "clickaway") dismiss(message.key) }}
                    sx={{ mb: index * 7 }}
                >
                    <Alert
                        severity={message.severity}
                        variant="filled"
                        onClose={() => dismiss(message.key)}
                        sx={{ width: "100%" }}
                    >
                        {message.text}
                    </Alert>
                </Snackbar>
            ))}
        </>
    )
}
